import { render } from "./SnackbarStore.vue?vue&type=template&id=03a43b65"
import script from "./SnackbarStore.vue?vue&type=script&lang=js"
export * from "./SnackbarStore.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__